<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<fuHeader />
		<crumbs :txt="a" type="2" height="43px" />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="gxBox">
				<div class="gxBoxR">
					<div class="gxBoxRT">
						<div class="gxBoxRTit">
							<h2>每期课件推荐</h2>
							<span @click="czFn">
								<img src="@/assets/img/sxIcon.svg" alt="" />
								重置
							</span>
						</div>
						<div class="gxBoxRTbox">
							<div class="gxBoxRTitem supHove3" :class="{ active: keywords.includes(item) }" @click="tabFn(item)" v-for="(item, index) in tabList" :key="index">
								{{ item }}
							</div>
						</div>
					</div>
					<div class="gxBoxRB">
						<div class="zzAdminConts">
							<div class="zzAdminCont" v-if="perData.length">
								<div class="zzAdminG supHove5" v-for="item in perData" :key="item.coursewarePeriodId">
									<div class="zzAdminItemImg" @click="btnFn(item.title, item.coursewarePeriodId)">
										<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
									</div>
									<div class="zzAdminItemP" @click="btnFn(item.title, item.coursewarePeriodId)">
										<div class="zzAdminItemTit">
											<p :title="item.title">{{ item.title }}</p>
											<div class="zzAdminItemYuy" @click.stop="scFn(item)" :class="item.isCollect ? 'active' : ''">
												<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="" />
												<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="" />
												<span>{{ item.isCollect ? '已收藏' : '收藏' }}</span>
											</div>
										</div>
										<div class="zzAdminItemJj">
											<div
												class="zzAdminItemJjI"
												:class="`zzAdminItemJjI${(tabList.indexOf(i) + 1) % 6}`"
												v-for="(i, index) in item.keywords?.split(',')"
												:key="index"
											>
												{{ i }}
											</div>
										</div>
										<div class="zzAdminItemCont" v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></div>
										<div class="zzAdminItemFot">
											<!-- <div class="zzAdminItemk">
						  编写人：{{item.createNickName}}
						</div> -->
											<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
										</div>
									</div>
								</div>
								<fenye :total="total" ref="fybox" @dataFn="perList" />
							</div>
							<div v-if="!perData.length">
								<el-empty description="暂无数据"></el-empty>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import userHeader from '@/components/hearder/userHeader';
import fuHeader from '@/components/hearder/fuHeader';
import fenye from '@/components/pubComponents/fenye';
import crumbs from '@/components/hearder/crumbs';
let names = '首页';

export default {
	name: 'kejianTj',
	data() {
		return {
			type: 1,
			txt: '',
			a: [],
			fullscreenLoading: false,
			keywords: '',
			perData: [],
			tabList: [],
			total: 0
		};
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		crumbs,
		fenye
	},
	methods: {
		scFn(item) {
			this.$scFn(
				{
					type: '5',
					assetsId: item.coursewarePeriodId
				},
				item.isCollect,
				this.perList,
				{
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				}
			);
		},
		tabFn(item) {
			if (this.keywords.includes(item)) {
				this.keywords = this.keywords.replace(item + ',', '');
			} else {
				this.keywords += item + ',';
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		czFn() {
			this.keywords = '';
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		btnFn(txt, id) {
			sessionStorage.setItem('tabFlag', '');
			this.$router.push({
				path: './mqDec',
				query: {
					type: 1,
					txt,
					coursewarePeriodId: id,
					crumFlag: 1,
					tabFtxt: ['首页', '每期课件']
				}
			});
		},
		// 列表
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			console.log(pre, 7777);
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydCoursewarePeriod/list', {
					params: {
						keywords: this.keywords,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			// 关键字
			this.$http.get('api/app/yydCoursewarePeriod/coursewarePeriodKeywords/list').then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.tabList = res.data.map((item) => {
						return item.resourceKeywordsName;
					});
				}
			});
			this.perList();
		}
	},

	beforeRouteEnter(to, from, next) {
		if (from.meta.name) {
			names = from.meta.name;
			console.log(names, 96662);
		}
		next();
	},
	activated() {
		const { txt, tabFtxt } = this.$route.query;
		if (tabFtxt) {
			this.a = [names, tabFtxt];
		}
		this.init();
		this.txt = txt || '';
	}
};
</script>
<style lang="scss" scoped>
.zzAdminTabs {
	height: 50px;
	background: #ffffff;
	border-radius: 6px 6px 0px 0px;
	display: flex;
	justify-content: space-between;
	padding: 0 15px 0 26px;
	border-bottom: 1px solid #f3f4f7;
	align-items: center;
	.zzAdminTabZj {
		font-size: 14px;
		span {
			color: #1d7b3a;
		}
	}
	.zzAdminTab {
		display: flex;
		font-size: 18px;
		color: #979797;
		align-items: center;
		.zzAdminItem {
			margin-right: 52px;
			cursor: pointer;
		}
		.active {
			color: #000;
			font-weight: bold;
		}
	}
	.zzAdminUp {
		display: flex;
		align-items: center;
		color: #1d7b3a;
		font-size: 14px;
		height: 100%;
		cursor: pointer;
		img {
			width: 16px;
			height: 16px;
			margin-right: 7px;
		}
	}
}
.zzAdminConts {
	background: #ffffff;
	border-radius: 0px 0px 6px 6px;
	padding: 0 15px;
	.zzAdminCont {
		margin-bottom: 10px;
		.zzAdminG {
			display: flex;
			padding: 15px 0;
			border-bottom: 1px solid #f8f8f8;
			align-items: center;
			&:last-of-type {
				border-bottom: none;
			}
			.zzAdminItemImg {
				width: 185px;
				height: 115px;
				margin-right: 18px;
				img {
					width: 100%;
					height: 100%;
					border-radius: 8px;
					object-fit: cover;
				}
			}
			.zzAdminItemImg1 {
				width: 84px;
				height: 84px;
			}

			.zzAdminItemP {
				flex: 1;
				padding-right: 30px;
				cursor: pointer;
				.zzAdminItemJj {
					display: flex;
					align-items: center;
					.zzAdminItemJjI {
						padding: 0 10px;
						height: 20px;
						font-size: 12px;
						text-align: center;
						line-height: 20px;
						border-radius: 4px;
						margin-right: 10px;
						margin-bottom: 5px;
					}
					.zzAdminItemJjI0 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI1 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI2 {
						background: #f6fcf1;
						color: #5ec009;
					}
					.zzAdminItemJjI3 {
						background: #f1f7fe;
						color: #1675e5;
					}
					.zzAdminItemJjI5 {
						background: #fbf3ff;
						color: #bf2ff9;
					}
					.zzAdminItemJjI4 {
						background: #f2f7f3;
						color: #1d7b3a;
					}
				}
				.zzAdminItemCont {
					font-size: 14px;
					margin-bottom: 5px;
					// 超出多行省略号
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				.zzAdminItemFot {
					display: flex;
					align-items: center;
					.zzAdminItemk {
						display: flex;
						align-items: center;
						color: #8f9190;
						font-size: 12px;
						margin-right: 29px;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
						}
					}
				}
				.zzAdminItemC {
					color: #aeaeae;
					font-size: 14px;
					width: 647px;
					margin-bottom: 5px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
				.zzAdminItemTit {
					display: flex;
					align-items: center;
					margin-bottom: 6px;
					.zzAdminItemStat {
						width: 44px;
						height: 20px;
						background: #1d7b3a;
						font-size: 14px;
						color: #fff;
						margin-right: 10px;
						border-radius: 4px;
						text-align: center;
						line-height: 20px;
					}
					p {
						font-size: 16px;
						color: #000000;
						font-weight: bold;
						max-width: 400px;
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
					}
					.infoMyIcon {
						display: flex;
						align-items: center;
						color: #93571c;
						font-size: 14px;
						margin-left: 14px;
						img {
							width: 14px;
							height: 14px;
							margin-right: 4px;
						}
					}
					.zzAdminItemYuy {
						display: flex;
						align-items: center;
						color: #999999;
						font-size: 14px;
						margin-left: 25px;
						line-height: 1;
						img {
							width: 14px;
							height: 14px;
							vertical-align: bottom;
							margin-right: 5px;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
			}
			.zzAdminItemDel {
				width: 75px;
				height: 30px;
				background: #1d7b3a;
				margin-right: 14px;
				cursor: pointer;
				text-align: center;
				line-height: 30px;
				color: #fff;
				border-radius: 6px;
				font-size: 14px;
				margin-top: -7px;
			}
		}
	}
}
.gxBox {
	width: 1200px;
	margin: 0 auto 10px;
	display: flex;
	min-height: calc(100vh - 429px);
	.gxBoxL {
		width: 230px;
		background: #ffffff;
		border-radius: 6px;
		padding: 17px 14px 0;
	}
	.gxBoxR {
		flex: 1;
		// margin-left: 10px;
		.gxBoxRT {
			background: #ffffff;
			border-radius: 6px;
			margin-bottom: 10px;
			padding: 17px 17px 11px;
			.gxBoxRTbox {
				display: flex;
				flex-wrap: wrap;
				max-height: calc(30px + 10px + 30px);
				overflow: hidden;
				.gxBoxRTitem {
					padding: 0 10px;
					height: 30px;
					background: #f3f4f7;
					border-radius: 4px;
					text-align: center;
					line-height: 30px;
					color: #000000;
					font-size: 14px;
					cursor: pointer;
					margin-right: 14px;
					margin-bottom: 10px;
					// &:nth-of-type(15n){
					//   margin-right: 0;
					// }
				}
				.active {
					background: #e5f2e9;
					color: #1d7b3a;
				}
			}
			.gxBoxRTit {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				color: #949494;
				margin-bottom: 20px;
				h2 {
					font-size: 14px;
					font-weight: normal;
				}
				span {
					display: flex;
					align-items: center;
					cursor: pointer;
				}
				img {
					width: 16px;
					height: 16px;
					margin-right: 4px;
				}
			}
		}
	}
}
.infoMyVip {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 75px;
	height: 18px;
	background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
	border-radius: 4px;
	color: #93571c;
	font-size: 12px;
	margin-left: 10px;

	img {
		width: 14px;
		height: 14px;
		margin-right: 2px;
	}
}
</style>
